import { asMultiStyleConfig } from '../../../../utils/theme';
var parts = ['container', 'footer'];
var baseStyle = () => ({
  container: {
    borderRadius: 0,
    border: '1px',
    borderColor: 'grey.450'
  },
  footer: {
    pt: {
      base: 0,
      md: 0
    },
    pb: {
      base: 12,
      md: 12
    },
    bg: 'grey.280',
    justifyContent: {
      base: 'flex-start',
      md: 'flex-start',
      mdlg: 'flex-start'
    },
    borderTop: 0
  }
});
export var Card = asMultiStyleConfig({
  parts,
  baseStyle
});